export enum ServiceType {
  BO = 'BO',
  Lib = 'Lib',
  Proc = 'Proc',
  Rpt = 'Rpt',
  UD = 'UD'
}
